module.exports = __webpack_public_path__ + "img/stop.bfdff30a.svg";